import axios from 'axios';
import urlConfig from '../../public/js/config'; // 路径配置
import {getToken} from '@/util/auth';

// 创建axios 实例
const service = axios.create({
    baseURL: urlConfig.apiUrl, // api的base_url
    timeout: 50000, // 请求超时时间
    headers: {
        'Cache-Control': 'no-cache',
    },
});

// request 拦截器
service.interceptors.request.use(
    (config) => {
        // 这里可以自定义一些config 配置
        if (getToken('access_token')) {
            config.headers.Authorization = `Bearer ${getToken('access_token')}`;
            // config.headers.Accept = 'text/html,application/xhtml+xml,application/xml'
        }
        return config;
    },
    (error) => {
        //  这里处理一些请求出错的情况
        Promise.reject(error);
    },
);

// response 拦截器
service.interceptors.response.use(
    (response) => {
        const res = response.data;
        // 这里处理一些response 正常放回时的逻辑

        return res;
    },
    (error) => {
        // 这里处理一些response 出错时的逻辑

        return Promise.reject(error);
    },
);

export default service;

